<template>
  <div id="unauthorized" class="fadein full-height w-full fadein">
    <div class="h-full flex justify-center items-center flex-col">
      <h1 class="text-4xl font-extrabold text-white mb-3">401</h1>
      <h2 class="text-white text-xl">{{ t('headline') }}</h2>
      <div class="flex mt-7">
        <router-link
          v-if="!state.userIsLoggedIn"
          to="/login"
          class="flex items-center justify-center soft-btn px-3 py-2 rounded-3xl cursor-pointer mr-3 w-24"
        >
          <a class="text-ml text-white">{{ t('login') }}</a>
        </router-link>
        <router-link v-else to="/dashboard" class="flex items-center justify-center regular-btn px-3 py-2 rounded-3xl cursor-pointer mr-3 w-24">
          <a class="text-ml text-white">{{ t('back') }}</a>
        </router-link>
        <router-link to="/login?join=true" class="flex items-center justify-center regular-btn px-3 py-2 rounded-3xl cursor-pointer mr-3 w-24">
          <a class="text-ml text-white">{{ t('join') }}</a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeMount, reactive } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { useUserStore } from '@/composables/userStore'

  const userStore = useUserStore()

  const messages = {
    no: {
      headline: 'Du har ikke påkrevd tillatelse for å vise denne siden',
    },
    en: {
      headline: "You don't have the required permissions to view this page",
    },
  }

  const { t } = useI18n({ messages })

  const state = reactive({
    userIsLoggedIn: false,
  })

  onBeforeMount(async () => {
    const { authenticated } = await userStore.actions.isValidSession()
    state.userIsLoggedIn = authenticated
  })
</script>

<style scoped>
  #unauthorized {
    background: linear-gradient(180deg, var(--lp-blue), var(--lp-gray));
    background-size: 100% 1100px;
    background-repeat: no-repeat;
    overflow: visible;
    min-height: 100vh;
  }
</style>
